import { useContext } from 'react';

// auth provider
import AuthContext from 'contexts/AuthContext';

// ==============================|| HOOKS - AUTH ||============================== //

const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) throw new Error('useAuth must be used inside AuthProvider');

  return context;
};

export default useAuth;
